<template>
  <w-setting-sliding-popup :title="title" ref="slidingPopup" width="500px" @close="close">
    <div slot="content">
      <el-form :model="trapData" ref="trapForm" label-position="top" label-width="120px" :rules="formRules">
        <el-row>
          <el-form-item label="OID" prop="snmptrapOid">
            <el-input v-model="trapData.snmptrapOid" />
          </el-form-item>
        </el-row>
        <el-row type="flex" justify="space-between" :gutter="20">
          <el-col :span="12">
            <el-form-item label="버전" prop="snmptrapVersion">
              <el-radio-group v-model="trapData.snmptrapVersion">
                <el-radio label="v1">v1</el-radio>
                <el-radio label="v2c">v2c</el-radio>
                <el-radio label="v3">v3</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Generic 타입" prop="snmptrapGenericId">
              <el-select v-model="trapData.snmptrapGenericId">
                <el-option v-for="generic in trapGenericSet" :key="generic.snmptrapGenericId"
                :label="generic.snmptrapGenericName" :value="generic.snmptrapGenericId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="Specific 타입" prop="snmptrapSpecificId">
            <el-input v-model="trapData.snmptrapSpecificId" :disabled="trapData.snmptrapGenericId !== 6" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="트랩명" prop="snmptrapName">
            <el-input v-model="trapData.snmptrapName" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="이벤트 메시지" prop="eventMessage">
            <!-- FIXME 키 범례 팝오버 -->
            <!-- <span slot="label">
              이벤트 메시지
              <el-popover placement="bottom" title="키 범례" width="300" trigger="click">
                <el-table-wrapper :data="trapMessagePopover" :columns="popoverColumns" :pagination="false" ></el-table-wrapper>
                <i slot="reference" class="fas fa-question c-pointer"></i>
              </el-popover>
            </span> -->
            <el-col :span="24">
              <el-input v-model="trapData.eventMessage" />
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="설명">
            <el-input type="textarea" :rows="3" v-model="trapData.oidDescr" resize="none"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="수집여부">
            <el-checkbox v-model="trapData.applyFlag" true-label="Y" false-label="N"/>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickClose">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';

import { isNumber } from '@/utils/number';
import msgUtils from '@/utils/message';
import integratedTrapSettingAPI from '@/api/settings/log/integrated-trap-settings';

export default {
  name: 'AddTrapPopup',
  props: {
    title: {
      type: String,
    },
    trapDatas: {
      type: Array,
    },
  },
  data() {
    /**
     * Snmptrap Generic 타입을 enterpriseSpecific으로 선택했을 때 specific 타입의 Validation을 check한다.
     * @author Minyeong
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    const snmptrapSpecificIdRule = (rule, value, callback) => {
      if (this.trapData.snmptrapGenericId === 6) {
        if (isEmpty(value)) {
          return callback(new Error('필수 정보입니다.'));
        }
        if (!isNumber(value)) {
          return callback(new Error('잘못된 입력입니다.'));
        }
      }
      return callback();
    };
    const eventMessageRule = (rule, value, callback) => {
      if (value && value.length > 255) {
        return callback(new Error('255자 이내로 입력해주세요.'));
      }
      return callback();
    };
    const trapNameRule = (rule, value, callback) => {
      if (value && value.length > 255) {
        return callback(new Error('255자 이내로 입력해주세요.'));
      }
      return callback();
    };
    /**
     * Snmptrap Oid와 Snmptrap Version의 중복 여부를 체크한다.
     * @author Minyeong
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    const snmptrapOidRule = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('필수 정보입니다.'));
      }
      if (!/^([1-9][0-9]{0,3}|0)(\.([1-9][0-9]{0,3}|0)){5,13}$/.test(value)) {
        return callback(new Error('잘못된 형식입니다.'));
      }
      const checkDupl = findIndex(this.trapDatas, {
        snmptrapOid: this.trapData.snmptrapOid,
        snmptrapVersion: this.trapData.snmptrapVersion,
        snmptrapSpecificId: isEmpty(this.trapData.snmptrapSpecificId) ? -1 : this.trapData.snmptrapSpecificId,
      });
      if (checkDupl !== -1) {
        return callback(new Error('이미 존재하는 트랩입니다.'));
      }
      return callback();
    };
    const formRules = {
      snmptrapOid: [
        { required: true, validator: snmptrapOidRule, trigger: 'blur' },
      ],
      snmptrapVersion: [
        { required: true, message: '필수 정보입니다.', trigger: 'change' },
      ],
      snmptrapGenericId: [
        { required: true, message: '필수 정보입니다.', trigger: 'change' },
      ],
      snmptrapSpecificId: [
        { required: true, validator: snmptrapSpecificIdRule, trigger: 'blur' },
      ],
      snmptrapName: [
        { validator: trapNameRule, trigger: 'blur' },
      ],
      eventMessage: [
        { validator: eventMessageRule, trigger: 'blur' },
      ],
    };
    const trapMessagePopover = [
      {
        key: '$ObjName$',
        descr: '대상명',
      },
      {
        key: '$EventlevelName$',
        descr: '이벤트 등급',
      },
      {
        key: '$VarValues$',
        descr: 'Sub OID 값',
      },
    ];
    const popoverColumns = [
      {
        prop: 'key',
        label: '키',
        align: 'center',
      },
      {
        prop: 'descr',
        label: '설명',
        align: 'center',
      },
    ];
    return {
      trapMessagePopover,
      popoverColumns,
      formRules,
      trapData: {
        snmptrapOid: '',
        snmptrapVersion: 'v1',
        snmptrapGenericId: '',
        snmptrapSpecificId: '',
        eventMessage: '',
        snmptrapName: '',
        oidDescr: '',
        applyFlag: 'Y',
      },
      trapGenericSet: [],
    };
  },
  created() {
    integratedTrapSettingAPI.getTrapGenericSet().then((response) => {
      this.trapGenericSet = response.data.data;
    }).catch((e) => {
      this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'Generic 타입', false));
      throw new Error(e);
    });
  },
  methods: {
    onSaveButton() {
      const params = [this.trapData];
      this.$refs.trapForm.validate().then((success) => {
        if (success) {
          integratedTrapSettingAPI.insertSnmptrap(params).then((response) => {
            if (response.data.success) {
              if (response.data.data === 'Duplicate') {
                this.$message(msgUtils.getCustomMsgData('이미 존재하는 트랩입니다.'));
                return;
              } else if (response.data.data === 'Error') {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '트랩', false));
              }
              this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '트랩', response.data.success));
              this.clickClose();
              this.$emit('insert-snmptrap');
            } else {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '트랩', response.data.success));
            }
          }).catch((e) => {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '트랩', false));
            throw new Error(e);
          });
        }
      }).catch(() => {});
    },
    close() {
      this.trapData = {
        snmptrapOid: '',
        snmptrapVersion: 'v1',
        snmptrapGenericId: '',
        snmptrapSpecificId: '',
        eventMessage: '',
        snmptrapName: '',
        oidDescr: '',
        applyFlag: 'Y',
      };
      // validation 초기화
      const clear = ['snmptrapOid', 'snmptrapVersion', 'snmptrapGenericId', 'snmptrapSpecificId', 'snmptrapName', 'eventMessage'];
      this.$refs.trapForm.clearValidate(clear);
    },
    clickClose() {
      this.$refs.slidingPopup.close();
      this.close();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/popup/AddTrapPopup.vue